<script>
import BaseImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/BaseImageElement.vue";
import {
  CustomLinkImageElementMixin,
} from "%/dynamic-component-editor/standard-elements/image-element/custom-link-image-element-mixin";

export default {
  name: "CustomLinkImageElement",
  extends: BaseImageElement,
  mixins: [CustomLinkImageElementMixin],
  elementPanelSettings: {
    displayName: "Image",
    elementGroup: "general",
    displayIcon: "image",
    elementType: "element",
  },
};
</script>

<style scoped lang="scss">

</style>
